import React, { useState } from "react";

const BForceSakshamBharat = () => {
  const [activeTab, setActiveTab] = useState("overview");

  const supervisoryPyramid = [
    { level: "Team Leaders (TL)", ratio: "1 per 5 Advisors", headcount: "2,18,000" },
    { level: "Assistant Managers (AM)", ratio: "1 per 5 TL", headcount: "43,600" },
    { level: "Managers (M)", ratio: "1 per 5 AM", headcount: "8,720" },
    { level: "Senior Managers (SM)", ratio: "1 per 5 M", headcount: "1,744" },
    { level: "AVP", ratio: "1 per 5 SM", headcount: "350" },
    { level: "VP", ratio: "1 per 5 AVP", headcount: "70" },
    { level: "SVP", ratio: "1 per 5 VP", headcount: "14" },
    { level: "President", ratio: "Fixed", headcount: "1" },
  ];

  const corePillars = [
    "SAKSHAM MSME",
    "SAKSHAM Agri & Rural",
    "SAKSHAM Shakti (Women)",
    "Modern Education + Skill Development Augmentation",
    "Purple Power + Golden 7 + YuvaSolvers",
    "Matrika",
    "SAKSHAM Shram",
    "SHEETAL"
  ];
  // (Systematic Holistic Efficiency Enhancement for Transparent Administration and Leadership)

  const deepTechPillars = [
    { tech: "🤖 AI/ML (Self-Reliance)", purpose: "Core decision & advisory engine" },
    { tech: "🔗 Blockchain", purpose: "Trust, traceability, governance" },
    { tech: "🏭 IIoT / Industry 5.0", purpose: "MSME & manufacturing productivity" },
    { tech: "🌐 Digital Twins", purpose: "Agriculture, cities, industry" },
    { tech: "🥽 Metaverse", purpose: "Content, community, commerce" },
    { tech: "⚛️ Quantum Computing", purpose: "Strategic capability & research (Long-term)" }
  ];

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-black via-gray-950 to-black text-white px-2 py-4 rounded-xl border-t-4 border-purple-600 max-w-5xl mx-auto">
      
      {/* HERO */}
      <div className="text-center mb-2">
        <div className="inline-flex w-full justify-center text-center items-center gap-1 bg-gradient-to-r from-purple-900 to-indigo-900 px-3 py-1 rounded-xl mb-2 border border-purple-500">
          <img
            src="/assets/flag-india.jpg"
            alt="India Map"
            className="w-8 h-8 lg:w-10 lg:h-10 object-contain"
          />
          <p className="text-sm lg:text-lg font-bold text-purple-200">B-FORCE</p>
          <p className="text-[10px] lg:text-xs text-purple-200">SAKSHAM Bharat in New AI Era</p>
        </div>
 
        <h1 className="text-[10px] lg:text-xs font-bold leading-tight">
          From the Land of Learning to the Engine of the Digital Future
        </h1>
        <p className="text-[10px] lg:text-xs text-purple-200 mt-2">
          Bharat Rising Again on Over 35 Crore Youth as of 2026
        </p>
        <p className="text-[10px] lg:text-xs text-purple-200 mt-2">
          Proposition: Growth with Think5Whys TaaP for Gen Z in India and Global South
        </p>
        <p className="text-[9px] lg:text-[10px] text-gray-300 mt-2 mb-2 border-t border-cyan-200 py-2">
            <span className="text-emerald-400">🌍 India & Global MSME Ecosystem</span>
            <span className="text-gray-500"> • </span>
            <span className="text-sky-400">🏠 Individuals</span>
            <span className="text-gray-500"> • </span>
            <span className="text-pink-400">👨‍👩‍👧‍👦 Families</span>
            <span className="text-gray-500"> • </span>
            <span className="text-yellow-400">🎓 Students</span>
            <span className="text-gray-500"> • </span>
            <span className="text-purple-400">🚀 Youth</span>
            <span className="text-gray-500"> • </span>
            <span className="text-cyan-400">💼 Professionals</span>
            <span className="text-gray-500"> • </span>
            <span className="text-indigo-400">🏫 Institutions</span>
            <span className="text-gray-500"> • </span>
            <span className="text-orange-400">🏢 Corporates</span>
            <span className="text-gray-500"> • </span>
            <span className="text-rose-400">🤝 International Trade</span>
            <span className="text-gray-500"> • </span>
            <span className="text-lime-400">🌾 Agri & Rural</span>
            <span className="text-gray-500"> • </span>
            <span className="text-red-400">🏛️ Government</span>
          </p>

        <div className="mt-2 flex flex-wrap justify-center gap-2">
          <div className="bg-emerald-900/70 px-2 py-1 rounded-xl border border-emerald-700 text-[10px] lg:text-xs">🚀 1–5 Million New Digital Jobs</div>
          <div className="bg-purple-900/70 px-2 py-1 rounded-xl border border-purple-700 text-[10px] lg:text-xs">📈 GDP & GSDPs Boost</div>
          <div className="bg-amber-900/70 px-2 py-1 rounded-xl border border-amber-700 text-[10px] lg:text-xs">🌍 Global Leadership</div>
        </div>
      </div>

      {/* TABS */}
      <div className="grid grid-cols-3 lg:grid-cols-7 gap-1 justify-center mb-2 border-b border-blue-800 pb-1 mt-2">
        {["overview", "framework", "ecosystem", "jobs", "impact", "deeptech", "platform"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-1 py-1 rounded-md text-[10px] lg:text-xs font-medium transition-all ${
              activeTab === tab 
                ? "bg-purple-600 text-white shadow-lg shadow-purple-500/50" 
                : "bg-gray-900 hover:bg-gray-800 text-gray-300 border border-gray-700"
            }`}
          >
            {tab === "overview" && "📍 Overview"}
            {tab === "framework" && "🏗️ B-FORCE"}
            {tab === "ecosystem" && "🌱 SAKSHAM"}
            {tab === "jobs" && "📊 Job Pyramid"}
            {tab === "impact" && "📈 Impact"}
            {tab === "deeptech" && "🔬 DeepTech"}
            {tab === "platform" && "⚙️ KRA"}
          </button>
        ))}
      </div>

      {/* OVERVIEW */}
      {activeTab === "overview" && (
        <div className="space-y-2">
          <div className="bg-gray-900 border border-purple-700 rounded-xl p-2">
            <h3 className="text-purple-300 font-semibold text-xs lg:text-sm mb-1">Vision</h3>
            <p className="text-[10px] lg:text-xs text-gray-100 leading-relaxed">
              B-FORCE stands for Bharat Framework for Outcomes, Resilience, Capability & Empowerment. 
              It is India’s integrated progressive digital transformation engine combining citizens, enterprises, 
              governance, deep-tech and culture into a single outcome-oriented framework.
            </p>
            <p className="text-[10px] lg:text-xs text-gray-100 mt-2">
              A transformative ecosystem — a platform beyond a website, portal, app or application — designed to be piloted internally first and then scaled to position India as a national and global leader in the data-led New World Order.
            </p>
          </div>

          <div className="bg-gray-900 border border-purple-700 rounded-xl p-2">
            <h3 className="text-purple-300 font-semibold text-[10px] text-xs mb-2">Vision By</h3>
            <p className="text-[10px] text-xs text-purple-200">Sanjeev Kumar</p>
            <p className="text-[10px] text-xs text-gray-400">Founder & Architect, Think5Whys Global DeepTech Solutions Private Limited, Mumbai</p>
          </div>
        </div>
      )}

      {/* B-FORCE FRAMEWORK */}
      {activeTab === "framework" && (
        <div className="bg-gray-900 border border-purple-700 rounded-xl p-2 space-y-2">
          <h3 className="text-cyan-200 font-semibold text-xs lg:text-sm">B-FORCE Framework</h3>
          
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-1">
            {[
              { l: "B", w: "Bharat", d: "The world’s ancient classroom to the new aspiring world’s digital engine." },
              { l: "F", w: "Foundations", d: "Education, Health, Financial & Cyber Literacy, Family, Community" },
              { l: "O", w: "Outcomes", d: "Jobs, income, productivity, MSME growth, citizen services" },
              { l: "R", w: "Resilience", d: "Agriculture, rural economy, women & SHGs, Youth, environment" },
              { l: "C", w: "Capability", d: "Skills, MSMEs, blue-collar, Digital Boutique, Micro-earning" },
              { l: "E", w: "Empowerment", d: "Citizens, women, entrepreneurs, advisors, institutions" }
            ].map((item) => (
              <div key={item.l} className="bg-gray-800 rounded-xl p-2 border border-gray-700">
                <span className="text-xs lg:text-sm font-bold text-purple-500 block mb-2">{item.l}</span>
                <p className="font-semibold text-purple-200 text-xs lg:text-sm">{item.w}</p>
                <p className="text-[10px] lg:text-xs text-gray-100 mt-1">{item.d}</p>
              </div>
            ))}
          </div>

          <div className="pt-2 border-t border-purple-800">
            <p className="text-xs lg:text-sm text-gray-100">
              <span className="text-purple-300 text-xs lg:text-sm font-medium">Prospect / Vision:</span> New Jobs. GSDP boost. Per Capita Income increase. Global Leadership. Worlds Data Science & BPM Backoffice. Democratising Six Sigma.
            </p>
          </div>
        </div>
      )}

      {/* SAKSHAM ECOSYSTEM */}
      {activeTab === "ecosystem" && (
        <div className="bg-gray-900 border border-purple-700 rounded-xl p-2">
          <h3 className="text-purple-300 font-semibold text-xs lg:text-sm mb-2">🌱 SAKSHAM Ecosystem</h3>
          <p className="text-emerald-300 text-[10px] lg:text-xs mb-2">Skilled And Keen Systematic Hands / Homes Achieves More</p>
          
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
            {corePillars.map((pillar, idx) => (
              <div key={idx} className="bg-gray-800 px-2 py-2 rounded-xl flex items-start gap-2 hover:border-purple-600 border border-transparent transition-all">
                <span className="text-purple-400 text-xs lg:text-sm mt-0.5">▸</span>
                <p className="text-[10px] lg:text-xs text-gray-100">{pillar}</p>
              </div>
            ))}
          </div>

          <div className="mt-2 pt-4 border-t border-blue-300">
            <h4 className="text-purple-300 font-medium text-[11px] lg:text-xs mb-2">Focus Segments (B-FORCE Lens)</h4>
            <div className="grid grid-cols-2 lg:grid-cols-2 gap-y-2 text-[10px] lg:text-xs text-gray-100">
              <div>Education & Skill Development → Foundations + Capability</div>
              <div>MSMEs → Outcomes + Capability</div>
              <div>Blue-collar Workers → Capability + Empowerment</div>
              <div>Agriculture & Rural Economy → Resilience + Outcomes</div>
              <div>Women (Housewives & SHGs) → Empowerment + Resilience</div>
              <div>Purple Power (Youth) → Foundations + Capability</div>
              <div>Health (Human & Pet/Vet) → Foundations + Resilience</div>
              <div>Individual / Family / Community → Foundations + Empowerment</div>
            </div>
          </div>
        </div>
      )}

      {/* JOB PYRAMID */}
      {activeTab === "jobs" && (
        <div className="bg-gray-900 border border-purple-700 rounded-xl p-2">
          <div className="flex justify-between items-start mb-2">
            <div>
              <h3 className="text-purple-300 font-semibold text-[10px] lg:text-xs">📊 Executive Public Advisors & Supervisory Pyramid</h3>
              <p className="text-emerald-400 text-[10px] lg:text-xs font-bold mt-1">10,90,000 Executive Advisors Envisioned in 3-5 Years</p>
            </div>
          </div>

          <div className="space-y-2">
            {supervisoryPyramid.map((row, i) => (
              <div key={i} className="bg-gray-800 rounded-xl p-2 flex flex-col lg:flex-row lg:items-center justify-between border-l-4 border-purple-600">
                <div className="flex flex-row justify-between">
                  <div className="flex flex-cols space-y-0 gap-2">
                    <p className="font-semibold text-purple-200 text-[10px] lg:text-xs">{row.level}</p>
                    <p className="text-[10px] lg:text-xs text-gray-400">{row.ratio}</p>
                  </div>
                  <div>
                    <p className="text-[10px] lg:text-xs font-bold text-emerald-400">{row.headcount}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-2 text-center bg-gray-950 border border-purple-800 rounded-xl py-2">
            <p className="text-purple-300 text-xs lg:text-sm font-bold">Total Supervisory Staff: 2,72,499</p>
          </div>
        </div>
      )}

      {/* IMPACT */}
      {activeTab === "impact" && (
        <div className="space-y-2">
          <div className="bg-gradient-to-br from-purple-900/40 to-indigo-900/40 border border-purple-600 rounded-xl p-2">
            <h3 className="text-purple-300 font-semibold text-xs lg:text-sm mb-2">🚀 Core Outcomes & Economic Impact</h3>
            <ul className="space-y-2 text-xs lg:text-sm text-gray-100">
              <li className="text-gray-100 text-[10px] lg:text-xs gap-2">• Creation of <span className="text-emerald-400 font-semibold">1-5 million</span> new work-from-home digital jobs, especially for educated youth and women</li>
              <li className="text-gray-100 text-[10px] lg:text-xs gap-2">• Additional increase in per capita income by ₹5,000–₹15,000</li>
              <li className="text-gray-100 text-[10px] lg:text-xs gap-2">• Additional 6–7% GSDP growth, driven by data-led digital initiatives</li>
              <li className="text-gray-100 text-[10px] lg:text-xs gap-2">• Positioning India as a net job creator in the digital economy and the world’s Data Science & BPM Backoffice</li>
            </ul>
          </div>

          <div className="bg-gray-900 border border-purple-700 rounded-xl p-2">
            <h3 className="text-purple-300 font-semibold mb-2 text-xs lg:text-sm">Five Strategic Moats for India</h3>
            <div className="space-y-2 text-xs lg:text-sm text-gray-100">
              <p className="text-gray-100 text-[10px] lg:text-xs gap-2">• Strong government willingness to adopt AI- and data-led transformation</p>
              <p className="text-gray-100 text-[10px] lg:text-xs gap-2">• A large, talented and cost-competitive youth workforce</p>
              <p className="text-gray-100 text-[10px] lg:text-xs gap-2">• Over 100 crore digitally aware residents of India</p>
              <p className="text-gray-100 text-[10px] lg:text-xs gap-2">• A significant non-resident Indian diaspora</p>
              <p className="text-gray-100 text-[10px] lg:text-xs gap-2">• Made in India. Made for India. Made for the World.</p>
            </div>
          </div>
        </div>
      )}

      {/* DEEPTECH */}
      {activeTab === "deeptech" && (
        <div className="bg-gray-900 border border-purple-700 rounded-xl p-2">
          <h3 className="text-cyan-200 font-semibold text-xs lg:text-sm mb-2">🔬 DeepTech Pillar (MVP & Roadmap)</h3>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
            {deepTechPillars.map((item, i) => (
              <div key={i} className="bg-gray-800 rounded-xl p-2">
                <p className="text-[10px] lg:text-xs font-semibold text-purple-300 mb-2">{item.tech}</p>
                <p className="text-[10px] lg:text-xs text-gray-100">{item.purpose}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* PLATFORM & KRA */}
      {activeTab === "platform" && (
        <div className="bg-gray-900 border border-purple-700 rounded-xl p-2 space-y-2">
          <div>
            <h3 className="text-cyan-200 font-semibold text-xs lg:text-sm mb-2">KRA & KPI Framework</h3>
            <p className="text-[10px] lg:text-xs text-gray-100 mb-2">Every KRA and KPI is directly generated by platform activity, making performance measurable, auditable, and incentive-linked.</p>
            {/* Could be expanded further with more tables if needed, but kept concise yet complete */}
          </div>

          <div>
            <h3 className="text-cyan-200 font-semibold text-xs lg:text-sm mb-2">Why This Holds Together</h3>
            <ul className="space-y-3 text-xs lg:text-sm text-gray-100">
              <li className="text-gray-100 text-[10px] lg:text-xs">• Job creation is a consequence of execution, not an assumption</li>
              <li className="text-gray-100 text-[10px] lg:text-xs">• GDP impact is driven by process improvement and productivity</li>
              <li className="text-gray-100 text-[10px] lg:text-xs">• India retains long-term strategic value through platform ownership and capability leadership</li>
            </ul>
          </div>
        </div>
      )}

      {/* FINAL CTA */}
      <div className="mt-2 bg-gradient-to-r from-purple-900/70 via-indigo-900/70 to-purple-900/70 border-2 border-purple-500 rounded-xl p-2 text-center">
        <h3 className="text-xs lg:text-sm text-cyan-200 font-bold mb-2">Learn • Build • Earn • Grow with SAKSHAM Bharat</h3>
        <p className="text-cyan-200 max-w-lg mx-auto text-[10px] lg:text-xs">
          Become part of India’s citizen-centric digital transformation. 
          Mobile First • Work From Anywhere • Powered by Deep Thinking + AI
        </p>
        <div className="mt-2 text-[10px] lg:text-xs uppercase tracking-widest text-purple-300">Join the B-FORCE Movement</div>
      </div>
    </div>
  );
};

export default BForceSakshamBharat;